import { render, staticRenderFns } from "./claimNotice_2021.vue?vue&type=template&id=0cc29ca8&scoped=true&"
import script from "./claimNotice_2021.vue?vue&type=script&lang=js&"
export * from "./claimNotice_2021.vue?vue&type=script&lang=js&"
import style0 from "./claimNotice_2021.vue?vue&type=style&index=0&id=0cc29ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc29ca8",
  null
  
)

export default component.exports